module.exports = __webpack_public_path__ + "static/media/timer.4b159228.svg";